import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import { dropTipoAvisoPrevio, dropMotivoCancelamentoAviso } from 'utils/drops';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const AvisoPrevio = ({ loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const avisos = pessoal?.Avisos ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalAvisoPrevio',
      id: item?.id,
      pessoal_id: pessoal?.id,
      dtavprv: item?.dtavprv || null,
      tpaviprevio: item?.tpaviprevio || null,
      dtprevdeslig: item?.dtprevdeslig || null,
      obsaviprevio: item?.obsaviprevio || '',
      dtcancavprv: item?.dtcancavprv || null,
      mtvcancavprevio: item?.mtvcancavprevio || null,
      obscancavprv: item?.obscancavprv || '',
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Aviso Prévio" disableMargin />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            type="date"
            name="dtavprv"
            control={control}
            label="Data do Aviso Prévio"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            control={control}
            name="tpaviprevio"
            label="Tipo de Aviso Prévio"
            options={dropTipoAvisoPrevio}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            type="date"
            control={control}
            name="dtprevdeslig"
            label="Data Prevista de Desligamento"
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            rows={3}
            multiline
            control={control}
            label="Observação"
            name="obsaviprevio"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Cancelamento" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            type="date"
            control={control}
            name="dtcancavprv"
            label="Data do Cancelamento"
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Dropdown
            control={control}
            name="mtvcancavprevio"
            label="Motivo do Cancelamento"
            options={dropMotivoCancelamentoAviso}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            rows={3}
            multiline
            control={control}
            name="obscancavprv"
            label="Observação do Cancelamento"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Avisos Prévio"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Aviso Prévio')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={avisos}
          columns={[
            {
              field: 'dtavprv',
              headerName: 'Data do Aviso',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'tpaviprevio',
              headerName: 'Tipo',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'dtprevdeslig',
              headerName: 'Data Prevista de Desligamento',
              width: 300,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'cancelado',
              headerName: 'Cancelado',
              width: 100,
              type: 'boolean',
              sortable: false,
              valueGetter: ({ row }) => Boolean(row?.dtcancavprv),
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Aviso Prévio')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalAvisoPrevio', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default AvisoPrevio;
